import React from 'react';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  return <>
      <SEO title="Impressum - CRM Kraft | Justus Kraft" description="Impressum und rechtliche Angaben von CRM Kraft - Justus Kraft. Kontaktdaten und Haftungsausschluss gemäß § 5 TMG." keywords="Impressum, CRM Kraft, Justus Kraft, rechtliche Angaben" ogType="website" data-id="element-432" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-433">
        <div className="max-w-4xl mx-auto" data-id="element-434">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-435">
            Impressum
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-436">
            <section className="mb-8" data-id="element-437">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-438">
                Adresse
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-439">
                CRM Kraft LLC
                <br data-id="element-440" />
                Vertreten durch: Justus Kraft
                <br data-id="element-441" />
                7901 4th St. N, Ste. 300
                <br data-id="element-442" />
                St. Petersburg, FL 33702
                <br data-id="element-443" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-444">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-445">
                Kontakt
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-446">
                Telefon:{' '}
                <a href="tel:+4915735999071" className="text-[#FF5722] hover:underline" data-id="element-447">
                  +49 157 35999071
                </a>
                <br data-id="element-448" />
                E-Mail:{' '}
                <a href="mailto:justus@crm-kraft.de" className="text-[#FF5722] hover:underline" data-id="element-449">
                  justus@crm-kraft.de
                </a>
              </p>
            </section>

            <section className="mb-8" data-id="element-450">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-451">
                EU-Streitschlichtung
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-452">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#FF5722] hover:underline" data-id="element-453">
                  https://ec.europa.eu/consumers/odr/
                </a>
                . Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section className="mb-8" data-id="element-454">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-455">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-456">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}